import React, {useEffect} from "react";
import * as ReactDOM from "react-dom";
import {useCustomerContext} from "../customer/CustomerContextProvider/CustomerContextProvider";
import NewsletterRegistrationInTextBlock from "./NewsletterRegistrationInTextBlock";
import NewsletterRegistrationFooterBlock from "./NewsletterRegistrationFooterBlock";
import {useTranslation} from "react-i18next";
import {getShopId} from "../lib/getShopId";
import formatCurrency from "../../helpers/formatCurrency";
import {CurrencyCode} from "@connox/typescript-library/types/cart/CurrencyCode";

const NewsletterRegistration: React.FC = () => {
  const {customer} = useCustomerContext();
  const {t} = useTranslation();
  const elements = document.getElementsByClassName("short-newsletter-block") as HTMLCollectionOf<HTMLDivElement>;

  useEffect(() => {
    if (!elements.length || customer.newsletterFlag) {
      return;
    }

    const footNotes = document.body.getElementsByClassName("foot-notes")[0];
    if (footNotes) {
      const paragraph = document.createElement("p");
      paragraph.classList.add("voucher-foot-note");
      const sup = document.createElement("sup");
      sup.innerText = "1";
      paragraph.append(sup);
      paragraph.append(
        " " +
          t(
            "BitteBeachtenSie",
            getShopId() === 100005
              ? {context: "noMinOrderValue"}
              : {minOrderValue: formatCurrency(79.0, window.c_ActiveCurrency as CurrencyCode)},
          ),
      );
      footNotes.insertAdjacentElement("beforeend", paragraph);
    }
  }, []);

  // Only show when div is present (by 'CTA_EMAIL' pseudo tag, or above the footer)
  // and customer has no newsletter yet
  if (!elements.length || customer.newsletterFlag) {
    return null;
  }

  return (
    <React.Fragment>
      {Array.from(elements).map((element, index) => {
        const {place} = element.dataset;

        return ReactDOM.createPortal(<NewsletterRegistrationBlock key={index} place={place} />, element);
      })}
    </React.Fragment>
  );
};

export default NewsletterRegistration;

const NewsletterRegistrationBlock: React.FC<{place?: string}> = ({place}) => {
  return place === "in-text" ? <NewsletterRegistrationInTextBlock /> : <NewsletterRegistrationFooterBlock />;
};
